import { ElementRef, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import Sortable from 'sortablejs';
import { addCalcInfo } from 'CalculationsApp/ts/state/calc-info.actions';
import { addFundChartCorrelation, removeFundChartCorrelation, setFundChartCorrelations, toggleFundChartCorrelation, updateFundChartCorrelation, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/correlations/correlations.actions';
import { addSecuritiesInfo } from 'SecuritiesApp/ts/state/securities-info/securities-info.actions';
import { getMaxCorrelationId } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/correlations/correlations.selectors';
import { CORRELATION_SECURITY_OPTIONS } from './fund-chart-correlations.constants';
import { ADVANCED_CHARTING_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { CorrelationType } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { CalculationsService } from 'CalculationsApp/ts/services/calculations.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { ChartCorrelationSelectorModalComponent } from '../chart-correlation-selector-modal/chart-correlation-selector-modal.component';
import { disablePointerEvents, enablePointerEvents } from 'NewAngular/utils/sortable-utils';
import * as i0 from "@angular/core";
import * as i1 from "CalculationsApp/ts/services/calculations.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "SecuritiesApp/ts/services/securities.service";
import * as i4 from "@ngrx/store";
import * as i5 from "../chart-correlation-selector-modal/chart-correlation-selector-modal.component";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i8 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/skeleton-loaders-list/skeleton-loaders-list.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["sortableCorrelationsContainer"];
const _c1 = ["correlationSelectorModalComponent"];
function FundChartCorrelationsComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function FundChartCorrelationsComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-skeleton-loaders-list", 15);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r1.isLoading)("numOfSkeletonLoaders", ctx_r1.correlations.length);
} }
function FundChartCorrelationsComponent_ng_template_18_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "label", 19)(3, "input", 20);
    i0.ɵɵlistener("click", function FundChartCorrelationsComponent_ng_template_18_div_0_Template_input_click_3_listener() { const index_r4 = i0.ɵɵrestoreView(_r3).index; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.toggleChartCorrelation(index_r4)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 21);
    i0.ɵɵelementStart(5, "span", 22);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 23)(8, "div", 24);
    i0.ɵɵlistener("click", function FundChartCorrelationsComponent_ng_template_18_div_0_Template_div_click_8_listener() { const ctx_r4 = i0.ɵɵrestoreView(_r3); const correlation_r6 = ctx_r4.$implicit; const index_r4 = ctx_r4.index; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.showEditCorrelationModal(correlation_r6, index_r4)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(10, "div", 26);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(11, "svg", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(12, "div", 28);
    i0.ɵɵlistener("click", function FundChartCorrelationsComponent_ng_template_18_div_0_Template_div_click_12_listener() { const index_r4 = i0.ɵɵrestoreView(_r3).index; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.removeChartCorrelation(index_r4)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(13, "svg", 29);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const correlation_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", i0.ɵɵinterpolate(correlation_r6.correlationId));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", correlation_r6.include);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getCorrelationDisplayName(correlation_r6), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.userHasAdvancedChartingFeature);
} }
function FundChartCorrelationsComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FundChartCorrelationsComponent_ng_template_18_div_0_Template, 14, 5, "div", 16);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r1.correlations);
} }
export class FundChartCorrelationsComponent {
    constructor(calculationsService, featureService, securitiesService, ngZone, store) {
        this.calculationsService = calculationsService;
        this.featureService = featureService;
        this.securitiesService = securitiesService;
        this.ngZone = ngZone;
        this.store = store;
        this.defaultOnly = false;
        this.isLoading = false;
        this.isFetchingCalcInfo = false;
        this.isFetchingSecuritiesInfo = false;
        this.calcFetchSubscription = null;
        this.securitiesFetchSubscription = null;
        this.correlations = [];
        this.securitiesInfo = {};
        this.mapStateToComponent = (state) => {
            this.mergeToTarget(state);
            this.maxCorrelationId = getMaxCorrelationId(state);
            this.correlations = state.fundChart.correlations;
            this.calcInfo = state.calcInfo;
            this.securitiesInfo = state.securitiesInfo;
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
        this.userHasAdvancedChartingFeature = this.featureService.userHasFeatures([ADVANCED_CHARTING_FEATURE]);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    ngAfterViewInit() {
        this.initializeSortable();
    }
    mergeToTarget(nextState) {
        const { fundChart: { correlations }, calcInfo, securitiesInfo, } = nextState;
        if (!correlations)
            return;
        // Check for missing calcInfo
        const calcsMissingInfo = [];
        const securitiesMissingInfo = [];
        correlations.forEach((correlation) => {
            const { securityA, securityB, metricA, metricB } = correlation;
            if (metricA && !calcInfo[metricA]) {
                calcsMissingInfo.push(metricA);
            }
            if (metricB && !calcInfo[metricB]) {
                calcsMissingInfo.push(metricB);
            }
            if (!securitiesInfo[securityA] && !CORRELATION_SECURITY_OPTIONS.includes(securityA)) {
                securitiesMissingInfo.push(securityA);
            }
            if (!securitiesInfo[securityB] && !CORRELATION_SECURITY_OPTIONS.includes(securityB)) {
                securitiesMissingInfo.push(securityB);
            }
        });
        if (calcsMissingInfo.length > 0) {
            if (this.calcFetchSubscription !== null) {
                this.calcFetchSubscription.unsubscribe();
            }
            this.isLoading = true;
            this.isFetchingCalcInfo = true;
            this.calcFetchSubscription = this.calculationsService
                .getCalcInfo(calcsMissingInfo)
                .subscribe((_calcInfo) => {
                this.store.dispatch(addCalcInfo({ calcInfo: _calcInfo }));
                this.isFetchingCalcInfo = false;
                this.isLoading = this.isFetchingCalcInfo || this.isFetchingSecuritiesInfo;
                if (!this.isLoading) {
                    // filter out calcs without info
                    const validCorrelations = correlations.filter(({ metricA, metricB }) => this.isValidCorrelationCalc(metricA) &&
                        this.isValidCorrelationCalc(metricB));
                    this.store.dispatch(setFundChartCorrelations({ correlations: validCorrelations }));
                }
            });
        }
        // Get missing securities info
        if (securitiesMissingInfo.length > 0) {
            if (this.securitiesFetchSubscription !== null) {
                this.securitiesFetchSubscription.unsubscribe();
            }
            this.isLoading = true;
            this.isFetchingSecuritiesInfo = true;
            this.securitiesFetchSubscription = this.securitiesService
                .getSecuritiesInfo(securitiesMissingInfo.join(','))
                .subscribe((_securitiesInfo) => {
                this.store.dispatch(addSecuritiesInfo({ securitiesInfo: _securitiesInfo }));
                this.isFetchingSecuritiesInfo = false;
                this.isLoading = this.isFetchingCalcInfo || this.isFetchingSecuritiesInfo;
                if (!this.isLoading) {
                    // filter out securities without info
                    const validCorrelations = correlations.filter(({ securityA, securityB }) => this.isValidCorrelationSecurity(securityA) && this.isValidCorrelationSecurity(securityB));
                    this.store.dispatch(setFundChartCorrelations({ correlations: validCorrelations }));
                }
            });
        }
    }
    isValidCorrelationCalc(calc) {
        // we allow empty metric names as some security types do not have metrics (i.e. indicators)
        return calc === '' || !!this.calcInfo[calc];
    }
    isValidCorrelationSecurity(security) {
        // for a correlation security to be valid, it must be a valid correlation security option
        // or have securities info
        return (CORRELATION_SECURITY_OPTIONS.includes(security) || this.securitiesInfo[security]);
    }
    getSecurityMetricDisplayName(metricId, securityId) {
        // If we are loading the calcInfo, return the label as '...'
        if (metricId && !this.calcInfo[metricId]) {
            return '...';
        }
        let securityName = '';
        switch (metricId) {
            case '_firstSecurity_':
                securityName = 'First Security';
                break;
            case '_listSecurity_':
                securityName = 'List Security';
                break;
            default:
                if (securityId && this.securitiesInfo[securityId]) {
                    securityName = this.securitiesInfo[securityId].display_security_id;
                }
                else {
                    securityName = '...';
                }
                break;
        }
        return metricId ? `${securityName} ${this.calcInfo[metricId].label}` : securityName;
    }
    getCorrelationDisplayName(correlation) {
        let corrA = this.getSecurityMetricDisplayName(correlation.metricA, correlation.securityA);
        let corrB = this.getSecurityMetricDisplayName(correlation.metricB, correlation.securityB);
        switch (correlation.correlationType) {
            case CorrelationType.RATIO:
                return `${corrA} / ${corrB}`;
            case CorrelationType.SPREAD:
                if (correlation.weightA !== 1) {
                    corrA += ` *${correlation.weightA}`;
                }
                if (correlation.weightB !== 1) {
                    corrB += ` *${correlation.weightB}`;
                }
                return `${corrA} - ${corrB}`;
            case CorrelationType.CORRELATION:
                const lookbackPeriod = correlation.lookbackWindow !== undefined ? ` [Period:${correlation.lookbackWindow}]` : '';
                if (correlation.lagA !== 0) {
                    corrA += ` [Lag:-${correlation.lagA}]`;
                }
                if (correlation.lagB !== 0) {
                    corrB += ` [Lag:-${correlation.lagB}]`;
                }
                return `Corr: ${corrA}, ${corrB}${lookbackPeriod}`;
            default:
                return '';
        }
    }
    showEditCorrelationModal(correlation, index) {
        let metricA;
        let metricB;
        if (correlation.metricA) {
            metricA = {
                id: correlation.metricA,
                name: this.calcInfo[correlation.metricA].label,
            };
        }
        if (correlation.metricB) {
            metricB = {
                id: correlation.metricB,
                name: this.calcInfo[correlation.metricB].label,
            };
        }
        const correlationData = {
            ...correlation,
            metricA,
            metricB,
        };
        this.showAddCorrelationModal(correlationData, index);
    }
    showAddCorrelationModal(correlationData, index = this.maxCorrelationId + 1) {
        if (this.userHasAdvancedChartingFeature) {
            this.correlationSelectorModalComponent.openModal(correlationData, index);
        }
    }
    addOrUpdateChartCorrelation({ correlation, correlationIndex, }) {
        if (this.correlations.some((existingCorrelation) => existingCorrelation.correlationId === correlation.correlationId)) {
            this.store.dispatch(updateFundChartCorrelation({ correlation, correlationIndex }));
        }
        else {
            this.store.dispatch(addFundChartCorrelation({ correlation }));
        }
    }
    toggleChartCorrelation(index) {
        this.store.dispatch(toggleFundChartCorrelation({ correlationIndex: index }));
    }
    removeChartCorrelation(index) {
        this.store.dispatch(removeFundChartCorrelation({ correlationIndex: index }));
    }
    updateOrdering(oldIndex, newIndex) {
        const correlations = this.correlations.map((correlation) => {
            return { ...correlation };
        });
        correlations.splice(newIndex, 0, correlations.splice(oldIndex, 1)[0]);
        this.store.dispatch(setFundChartCorrelations({ correlations }));
    }
    initializeSortable() {
        const className = 'correlations-list-item-container';
        Sortable.create(this.sortableCorrelationsContainer.nativeElement, {
            handle: '.btn-reorder-up',
            ghostClass: 'report-module-ghost',
            scroll: false,
            animation: 150,
            onUpdate: (evt) => {
                // The Sortable library is outside of our Angular context so we need to wrap
                // our handler in a $apply statement so that we are within a digest cycle.
                this.ngZone.run(() => {
                    this.updateOrdering(evt.oldIndex, evt.newIndex);
                });
                // This is a workaround for a bug in the Sortable library which can recheck
                // unchecked items after dragging. There is no entrypoint provided by SortableJS
                // after it updates the checkbox state, so we need to delay execution.
                setTimeout(() => {
                    const { children } = evt.target;
                    this.correlations.forEach((correlation) => {
                        for (let i = 0; i < children.length; i += 1) {
                            const child = children[i];
                            if (correlation.correlationId.toString() === child.dataset.id) {
                                const el = child.getElementsByClassName('custom-control-input');
                                if (el && el[0].itemIsSelected !== correlation.include) {
                                    el[0].itemIsSelected = correlation.include;
                                }
                            }
                        }
                    });
                });
            },
            onStart: () => {
                // Prevent pointer-events on btn classes on click in modules-container for tooltip/sortable bug
                disablePointerEvents(document, className);
            },
            onEnd: () => {
                enablePointerEvents(document, className);
            },
        });
    }
}
FundChartCorrelationsComponent.ɵfac = function FundChartCorrelationsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartCorrelationsComponent)(i0.ɵɵdirectiveInject(i1.CalculationsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.SecuritiesService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i4.Store)); };
FundChartCorrelationsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartCorrelationsComponent, selectors: [["ycn-fund-chart-correlations"]], viewQuery: function FundChartCorrelationsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortableCorrelationsContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.correlationSelectorModalComponent = _t.first);
    } }, inputs: { defaultOnly: "defaultOnly" }, standalone: false, decls: 21, vars: 7, consts: [["correlationSelectorModalComponent", ""], ["sortableCorrelationsContainer", ""], ["skeletonLoadersList", ""], ["correlationsList", ""], [1, "panel-sidebar-section-header"], [1, "panel-sidebar-section-row"], [1, "panel-sidebar-section-title", "user-select-none"], [1, "divider-vertical"], [1, "panel-sidebar-section-control"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnIcon", "", "name", "icon-add"], [3, "handler", "maxCorrelationId", "defaultOnly"], [1, "panel-sidebar-section-body", 3, "hidden"], ["id", "correlations-list-container", 1, "options-list", "user-select-none"], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "loading", "numOfSkeletonLoaders"], ["class", "options-list-item-header correlations-list-item-container", 3, "id", 4, "ngFor", "ngForOf"], [1, "options-list-item-header", "correlations-list-item-container", 3, "id"], [1, "options-list-item-title"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", "name", "correlations-list", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "options-list-item-controls"], ["ycnDisabled", "", "ycnTooltip", "", "tooltipPlacement", "left", "tooltipTitle", "Edit", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "disabled"], ["ycnIcon", "", "name", "icon-edit"], ["ycnTooltip", "", "tooltipTitle", "Reorder", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-reorder-up"], ["ycnIcon", "", "name", "icon-reorder-up"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", "name", "icon-close"]], template: function FundChartCorrelationsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
        i0.ɵɵtext(3, "Ratios / Spreads / Correlations");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "div", 7);
        i0.ɵɵelementStart(5, "div", 8)(6, "a", 9);
        i0.ɵɵlistener("click", function FundChartCorrelationsComponent_Template_a_click_6_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.showAddCorrelationModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(7, "svg", 10);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(8, "span");
        i0.ɵɵtext(9, "Create");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "ycn-chart-correlation-selector-modal", 11, 0);
        i0.ɵɵlistener("handler", function FundChartCorrelationsComponent_Template_ycn_chart_correlation_selector_modal_handler_10_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addOrUpdateChartCorrelation($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(12, "div", 12)(13, "div", 13, 1);
        i0.ɵɵtemplate(15, FundChartCorrelationsComponent_ng_container_15_Template, 1, 0, "ng-container", 14)(16, FundChartCorrelationsComponent_ng_template_16_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(18, FundChartCorrelationsComponent_ng_template_18_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(20, "ycn-feature-needed");
    } if (rf & 2) {
        const skeletonLoadersList_r7 = i0.ɵɵreference(17);
        const correlationsList_r8 = i0.ɵɵreference(19);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", !ctx.userHasAdvancedChartingFeature);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("maxCorrelationId", ctx.maxCorrelationId)("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.correlations.length === 0);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isLoading)("ngIfThen", skeletonLoadersList_r7)("ngIfElse", correlationsList_r8);
    } }, dependencies: [i5.ChartCorrelationSelectorModalComponent, i6.NgForOf, i6.NgIf, i7.DisabledDirective, i8.FeatureNeededComponent, i9.IconDirective, i10.SkeletonLoadersListComponent, i11.TooltipDirective], encapsulation: 2 });
